import { departmentDashboard } from '../../actions/constant';

const {
  GET_ALL_PHYSICIANS_SUCCESS,
  GET_ALL_PHYSICIANS_FAILURE,
  GET_ALL_PHYSICIANS_LOADING,
  GET_ALL_PHYSICIANS_RESET,
} = departmentDashboard;

const initialState: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loading: false,
};

export const getAllPhysiciansReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_PHYSICIANS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_PHYSICIANS_SUCCESS:
      return {
        ...state,
        isError: false,
        loading: false,
        response: action.payload?.data,
      };
    case GET_ALL_PHYSICIANS_FAILURE:
      return {
        ...state,
        isError: true,
        loading: false,
        errorMessage: action.payload,
        response: null,
      };
    case GET_ALL_PHYSICIANS_RESET:
      return initialState;
    default:
      return state;
  }
};
